export default {
    AGUARDANDO_ABERTURA: 'Aguardando Abertura',
    ABERTA: 'Aberta',
    EM_ELABORACAO: 'Em Elaboração',
    EM_ANALISE: 'Em Análise',
    ENCERRADA: 'Encerrada',
    REANALISE: 'Reanálise',
    PROCESSANDO: 'Processando',
    SUSPENSA: 'Suspensa'
}
